module.exports = __webpack_public_path__ + "img/lock.17ab5654.svg";